import HTTP from "../HTTP";

export default {
  async updateProfilePicture(payload) {
    try {
      let id = payload.get("profile_id");
      let response = await HTTP.cloudinary.post("/upload", payload);
      let profile_picture = response.data.secure_url;

      let data = {
        data: {
          type: "profiles",
          id,
          attributes: {
            profile_picture
          }
        }
      };

      let res = await HTTP.normal.patch(`/profiles/${id}`, data);

      return res.data.data.attributes.profile_picture;
    } catch (e) {
      return e;
    }
  },

  async updateBio(payload) {
    try {
      let id = payload.profile_id;

      let data = {
        data: {
          type: "profiles",
          id,
          attributes: {
            bio: payload.bio
          }
        }
      };

      await HTTP.normal.patch(`/profiles/${id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar a biografia!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/profile.js